export default __webpack_public_path__ + "static/media/FourHalfStarsNumber.1db66f18.svg";